var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var FeatureBuilder = require('./FeatureBuilder')

var {
  AppRegistry,
  Text,
  View,
  
  StyleSheet,
} = ReactNative;

var ReUpTabContentContainer = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager: {},
      activeTop:100,
      height:200,
      width:300,
      layout:{},
    }
  },

  getInitialState : function()
  {
    return {
      tabIndexSelected: this.props.initialTabSelected,
      visible: false,
      opacity: new Animated.Value(1),
      newFeatureOpacity: new Animated.Value(1),
      activeTop:this.props.activeTop,
      height:this.props.activeHeight,
      width:this.props.width,
      currentTop: new Animated.Value(this.props.height + this.props.activeTop + 10),
      currentFeatureView: null,
      previousFeatureView: null,
      layout:this.props.layout,
      currentFeature:{name:"none"},
      previousFeature:{name:"none"},
    }
  },

  componentWillReceiveProps: function(newProps)
  {
    this.setState(newProps)

    var thisThing = this;
    if( this.state.visible )
    {
      setTimeout(function()
      {
        thisThing.showFeature();
      },200)
    }
  },

  _attemptedFeature: null,
  _attemptedFeatureExtras: null,
  showFeature(feature, extras, animate, doThisIfHadToLogIn, doThisBeforeAttemptLogin)
  {
    var thisThing = this;
    if( typeof animate === 'undefined' ) animate = true;
    if( typeof feature !== 'undefined' )
    {
      this._attemptedFeature = null;

      var appManager = this.props.appManager;

      var needsLogin = feature.data.requiresLogin;
      if( needsLogin && !appManager.isLoggedIn() )
      {
        doThisBeforeAttemptLogin();
        this.props.appActions.requestFeatureName("Login", {}, true, function()
        {
          thisThing.showFeature(feature);
          if( typeof doThisIfHadToLogIn !== 'undefined' ) doThisIfHadToLogIn();
        });
        return;
        var loginFeature = appManager.getFeatureForName("Login");
        this.showFeature(loginFeature, {shadowEnabled:false}, animate);
        this._attemptedFeature = feature;
        this._attemptedFeatureExtras = extras;
      }
      else
      {
        if( typeof extras === 'undefined' ) extras = {};
        extras.shadowEnabled = false;
        var featureView = FeatureBuilder.featureForData( feature, this.state.layout, this.props.appManager, extras)
        if( this.state.visible )
        {
          setTimeout(function()
          {
            thisThing.state.newFeatureOpacity = new Animated.Value(1);
            // thisThing.state.newFeatureOpacity = new Animated.Value(0);
            thisThing.setState({previousFeatureView:thisThing.state.currentFeatureView, previousFeature: thisThing.state.previousFeature, currentFeatureView: featureView, currentFeature: feature, newFeatureOpacity: new Animated.Value(1)})
            // setTimeout(function()
            // {
            //   Animated.timing(
            //    thisThing.state.newFeatureOpacity,
            //    {toValue: 1,
            //    duration:0},
            //   ).start(function()
            //   {
            //     // thisThing.setState({previousFeatureView:null});
            //   });
            // }, 0)
          }, 0)

        }
        else
        {
          this.setState({currentFeatureView: featureView, currentFeature: feature})
        }
      }
    }

    this.setVisible(true, animate);
  },

  hideFeature(animate)
  {
    if( typeof animate === 'undefined' ) animate = true;
    this.setVisible(false, animate)
  },

  setVisible : function(visible, animated)
  {
    if( typeof animated === 'undefined' ) animated = true;
    if( visible == this.state.visible ) return;

    var thisThing = this;
    this.setState({visible:visible});
    if( visible )
    {
      Animated.spring(
        thisThing.state.currentTop,
        {
          toValue: thisThing.state.activeTop,
          tension: 100,
          friction: 15,
        },
      ).start();
    }
    else
    {
      Animated.spring(
        thisThing.state.currentTop,
        {
          toValue: thisThing.state.height + this.props.activeTop + 10,
          tension: 100,
          friction: 15,
        },
      ).start();
    }
  },

  render: function()
  {
    var thisThing = this;
    var visible = this.state.visible;

    return (
      <Animated.View style={{shadowColor:'black', backgroundColor:'transparent', shadowOpacity:0.8, shadowRadius:4, shadowOffset:{width:0, height:0}, position:'absolute', top:this.state.currentTop, width:this.state.width, height:this.state.height, borderTopLeftRadius:20, borderTopRightRadius:20}}>
        <View style={{overflow:'hidden', backgroundColor:'transparent', borderTopLeftRadius:20, borderTopRightRadius:20}}>
          <View style={{marginTop:-this.state.activeTop, height:this.state.height + this.state.activeTop}}>
            <Animated.View key={this.state.previousFeature.name} style={{position:'absolute', width:this.state.width, height:this.state.height + this.state.activeTop}}>
              {this.state.previousFeatureView}
            </Animated.View>
            <Animated.View key={this.state.currentFeature.name} style={{opacity:1, position:'absolute', width:this.state.width, height:this.state.height + this.state.activeTop}}>
              {this.state.currentFeatureView}
            </Animated.View>
          </View>
        </View>
      </Animated.View>
    )
  }
});

module.exports = ReUpTabContentContainer;



// WEBPACK FOOTER //
// ./src/ReUpTabContentContainer.js